import { render, staticRenderFns } from "./DetailsSectionFiles.vue?vue&type=template&id=565ad034&"
import script from "./DetailsSectionFiles.vue?vue&type=script&lang=js&"
export * from "./DetailsSectionFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports